module.exports = __webpack_public_path__ + "static/img/haiwai_01.b3df146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callMe/haiwai_01.png
// module id = axzL
// module chunks = 3